<template>
  <v-main class="product-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>商品</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-container fluid class="content">
      <ProductList />
      <PaywallList />
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { homeStore } from '@/store/home'
import ProductList from './ProductList.vue'
import PaywallList from './PaywallList.vue'
import { productStore } from '@/store/product'
import { paywallStore } from '@/store/paywall'

export default {
  name: 'ProductPage',
  components: { AppbarBackIcon, ProductList, PaywallList },
  data() {
    return {}
  },
  computed: {},
  async mounted() {
    await homeStore.doLoad()
    await productStore.doLoad()
    await paywallStore.doLoad()
  },
  methods: {},
}
</script>

<style lang="less" scoped></style>
